import { queryOptions } from '@tanstack/react-query'
import { reservationApi } from './api'
import { ReservationFiltersShape } from './models'
import { Pagination } from '@thinknimble/tn-models'

export const reservationQueries = {
  all: () => ['reservations'],
  retrieve: (id: string) =>
    queryOptions({
      queryKey: [...reservationQueries.all(), id],
      queryFn: () => reservationApi.retrieve(id),
      enabled: Boolean(id),
    }),
  list: ({
    filters,
    pagination,
    paginationCallback,
  }: {
    filters?: Partial<ReservationFiltersShape>
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  }) =>
    queryOptions({
      queryKey: [...reservationQueries.all(), { filters, pagination }],
      queryFn: async () => {
        const res = await reservationApi.list({ filters, pagination })
        const serverPagination = new Pagination({ ...res, totalCount: res.count })
        paginationCallback?.(serverPagination)
        return res
      },
      enabled: true,
    }),
}
